<app-standard-table class="flex-1 flex flex-col min-h-0" [title]="'admin.lotteryList'" [columns]="columnList"
  [data]="tableDataFilters" [totalItems]="totalItems" [pageSize]="pageSize" [isLoading]="isLoading"
  [currentPage]="currentPage" [showSearch]="false" (searchChange)="search($event)" (sortChange)="onSort($event)"
  (pageChange)="onPageChange($event)" (rowClick)="onClickRow($event)" (create)="openCreateModal()"
  (edit)="onEdit($event)" (delete)="onDelete($event)"></app-standard-table>


<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
       <h3>{{ (isEditMode ? 'modal.editLottery' : 'modal.createLottery') | translate }}</h3>
      <button class="close-icon" (click)="closeModal()">&times;</button>
    </div>

    <form (ngSubmit)="submit()" #lotteryForm="ngForm">
      <div class="form-body">
        <div
          class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center text-sm text-gray-500 cursor-pointer hover:border-[var(--primary)] transition"
          (click)="triggerFileInput()">
           {{ 'modal.uploadIcon' | translate }}
        </div>

        <input type="file" #fileInput accept="image/*" style="display: none" (change)="onFileSelected($event)" />

        <img *ngIf="imagePreview" [src]="imagePreview" class="mt-2 w-[300px] mx-auto" />
        <div class="form-group">
           <label for="number">{{ 'modal.price' | translate }}</label>
           <input type="text" id="number" name="number" [(ngModel)]="newLottery.price" [placeholder]="'modal.enterPrice' | translate" required
            class="form-input">
        </div>
      </div>

      <div class="modal-footer">
         <button type="button" class="btn-cancel" (click)="closeModal()" [disabled]="isSaving">{{ 'admin.cancel' | translate }}</button>
        <button type="submit" class="btn-create" [disabled]="!lotteryForm.form.valid || isSaving">
           <span *ngIf="!isSaving">{{ (isEditMode ? 'modal.updateLottery' : 'modal.createLotteryBtn') | translate }}</span>
           <span *ngIf="isSaving">{{ 'modal.saving' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
</div>